import React from 'react';
import AclTabViewContainer from 'js/components/elements/aclView/AclTabViewContainer';
import { ACL_RESOURCE_TYPE_DF_DATASET } from 'js/constants/aclConstants';

interface ShareTabProps {
  dataset: {
    id: number;
    [key: string]: any;
  };
}

export const ShareTab = ({ dataset }: ShareTabProps) => {
  return <AclTabViewContainer resourceType={ACL_RESOURCE_TYPE_DF_DATASET} data={dataset} />;
};
